import AddToCollectionPopup from 'desktop/components/add_to_collection_popup';

export default class CreateCollectionPopup {
  constructor(options) {
    this.el = $(options.element);
    this.ui = {
      inputName: 'input.popup__new-collection-name',
      simpanButton: 'button.popup__save-new-collection'
    };
    this.newCollectionName = null;
    this.videoId = this.el.data("video-id");
    var addTocollectionPopupEl = $('.js-component[data-component="AddToCollectionPopup"]').get(0);
    this.addCollectionPopup = new AddToCollectionPopup({element:addTocollectionPopupEl});
  }

  init() {
    this.el.on('click', this.createNewCollectionClick.bind(this));
    $(this.ui.inputName).hide();
    $(this.ui.simpanButton).hide();
  }

  createNewCollectionClick() {
    this.el.hide();

    $(this.ui.inputName).show();
    $(this.ui.simpanButton).show();
    $(this.ui.simpanButton).on('click', this.saveCollectionClick.bind(this));
    $(this.ui.inputName).focus();
  }

  saveCollectionClick(){
    this.newCollectionName = $(this.ui.inputName).val();
    this.ajaxNewCollection();
  }

  ajaxNewCollection(){
    $.ajax({
      method: 'POST',
      url: '/collections.json?video_id=' + this.videoId,
      dataType: 'json',
      data: { channel_name: this.newCollectionName },
      success: this.addCollectionPopup.onAddVideoToCollectionSuccess.bind(this.addCollectionPopup),
      error: this.addCollectionPopup.onAddVideoToCollectionFailed.bind(this.addCollectionPopup)
    })
    .done(this.addCollectionPopup.onAddVideoToCollectionSuccess.bind(this.addCollectionPopup))
    .fail(this.addCollectionPopup.onAddVideoToCollectionFailed.bind(this.addCollectionPopup));
  }
}
